import type { LLMMessage } from './llmTypes';

export class PromptBuilder {
  static buildJsonUserPrompt(userInstruction: string, outputTag: string, schemaDescription: string = ''): string {
    return `
# Task
${userInstruction}

# Output Requirement
你必须输出一个严格符合 JSON 格式的对象，并将其包裹在 XML 标签 <${outputTag}> 中。

# JSON Structure
${schemaDescription ? `返回的 JSON 必须严格遵守以下结构：\n${schemaDescription}` : '请确保返回的是合法的 JSON。'}

# Critical Constraints
1. 输出必须只包含 XML 标签及其内部的 JSON 内容，不要有任何开场白或结束语。
2. JSON 必须是标准的、可解析的格式（属性名必须用双引号）。
3. **绝对禁止**使用 Markdown 代码块（如 \`\`\`json）。
4. **绝对禁止**在 XML 标签外输出任何文字。
5. 确保 JSON 中的所有枚举值严格匹配要求。

# Example Output
<${outputTag}>
{
  ... (你的 JSON 数据)
}
</${outputTag}>
`.trim();
  }

  /**
   * 构建结构化消息（与 Chat Completions 风格对齐）
   */
  static buildJsonMessages(
    systemInstruction: string,
    userInstruction: string,
    outputTag: string,
    schemaDescription: string = '',
  ): LLMMessage[] {
    const userPrompt = this.buildJsonUserPrompt(userInstruction, outputTag, schemaDescription);
    const messages: LLMMessage[] = [];

    if (systemInstruction.trim().length > 0) {
      messages.push({
        role: 'system',
        content: systemInstruction.trim(),
      });
    }

    messages.push({
      role: 'user',
      content: userPrompt,
    });

    return messages;
  }
}
